import { useDocRect } from 'common/Prose/hooks/useDocRect'
import { GapCursor } from 'common/Prose/Plugins/GapCursor/gapCursor'
import { CSSProperties, forwardRef, useEffect, useMemo } from 'react'
import { useReactNodeView } from '../ReactNodeView/ReactNodeViewContext'
import styles from './ColumnGroup.module.scss'

export const ColumnGroup = forwardRef<HTMLDivElement, {}>((props, contentDomRef) => {
  const { nodeView, view, getPos } = useReactNodeView()
  const columnCount = view.state.doc.resolve(getPos()).nodeAfter?.childCount ?? 2

  useEffect(() => {
    if (nodeView) {
      nodeView.ignoreMutation = () => true
    }
  }, [nodeView])

  useEffect(() => {
    if (nodeView && view) {
      nodeView.stopEvent = (e) => {
        if (e instanceof MouseEvent && e.target instanceof HTMLDivElement && e.target.dataset.type === 'column') {
          const {
            state: { tr },
            dispatch,
          } = view
          e.preventDefault()

          const columnPos = view.posAtDOM(e.target, 0)
          const columnNode = tr.doc.resolve(columnPos).node()
          const columnSize = columnNode.content.size
          const end = columnPos + columnSize

          dispatch(tr.setSelection(new GapCursor(tr.doc.resolve(end))))

          return true
        }
        return false
      }
    }
  }, [nodeView, view])

  const docWidth = useDocRect(view)?.width

  const columnWidth = useMemo(() => {
    if (docWidth) {
      const numberOfGaps = columnCount - 1
      const maxColWidth = (docWidth - 24 * numberOfGaps) / columnCount
      return maxColWidth
    }
  }, [docWidth, columnCount])

  return (
    <>
      <div
        className={styles.ColumnGroup}
        ref={contentDomRef}
        data-columns={columnCount}
        style={columnWidth ? ({ '--column-width': `${columnWidth}px` } as CSSProperties) : undefined}
      />
    </>
  )
})
